module.exports = __webpack_public_path__ + "img/unexist_blog.6919efa.png";